export const role = {
  SUPER_ADMIN: 'SUPER_ADMIN',
  ADMIN: 'ADMIN',
  MANAGER: 'MANAGER',
  RESOLVER: 'RESOLVER',
  REVIEWER: 'REVIEWER',
};

export function isSuperAdmin(roleType: string): boolean {
  return (roleType === role.SUPER_ADMIN);
}

export function isAdmin(roleType: string): boolean {
  return (roleType === role.ADMIN);
}

export function isResolver(roleType: string): boolean {
  return (roleType === role.RESOLVER);
}

export function isReviewer(roleType: string): boolean {
  return (roleType === role.REVIEWER);
}
